<ngb-tabset #t="ngbTabset" id="settings-panel">
  <ngb-tab id="alarm" title="Alarm">
    <ng-template ngbTabContent>
      <email-alert></email-alert>
    </ng-template>
  </ngb-tab>

  <ngb-tab id="cost" title="Cost">
    <ng-template ngbTabContent>
    </ng-template>
  </ngb-tab>

  <ngb-tab id="shift-timing" title="Shift timing">
    <ng-template ngbTabContent>
    </ng-template>
  </ngb-tab>

</ngb-tabset>
